export default __webpack_public_path__ + "static/media/ruLogo-black-theme.a211faf9.svg";